import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import Paper from "@/app/pages/contactProfile/Paper";
import { ContactProfileFaq, ContactProfileFaqFragmentParameter } from "@/app/pages/contactDirectory/interface";
import { addViewportIsMobileListener, getViewportIsMobile } from "@/shared/FunctionCore";
import "@/app/pages/contactProfile/styles/ContactProfileFAQStyles.scss";

interface FaqCardProps {
	"contactProfileFaq": ContactProfileFaq;
	"index": number;
}

const FaqCard = (props: FaqCardProps): JSX.Element => {
	const {
		contactProfileFaq,
		index
	} = props;

	const {
		answer,
		expanded,
		question
	} = contactProfileFaq;

	const [isExpanded, setIsExpanded] = useState(expanded);

	return (
		<div className={index === 0 ? "faq-card-full" : "faq-card"}>
			<div
				className="row px-2"
				onClick={() => setIsExpanded((bo) => !bo)}>
				<div
					className="col-xs-10 col-sm-11 question overflow-text-ellipsis"
					title={question}>
					{question}
				</div>
				<div className={classnames({
					"col-xs-1 col-sm-2 float-right": true,
					"minimize-arrow": expanded,
					"expand-arrow": !expanded
				})} />
				{/* <div className={cx("col-xs-1", "col-sm-2", "float-right", classCombiner(styles, expanded ? "minimize-arrow" : "expand-arrow"))} /> */}
			</div>

			{isExpanded
				?
				<div className="answer">
					{answer}
				</div>
				: <></>}
		</div>
	);
};

type ContactProfileFaqFragmentComponentProps = ContactProfileFaqFragmentParameter;

const ContactProfileFAQ = (props: ContactProfileFaqFragmentComponentProps): JSX.Element => {
	const { contactProfileFaqResult } = props;

	const {
		contactProfileFaqCollection,
		contactProfilePageData
	} = contactProfileFaqResult;

	const {
		contact,
		contactCompanyProfileHref
	} = contactProfilePageData;

	const {
		familyName,
		givenName
	} = contact;

	const { organization } = contact;

	// TODO "!"
	const { primaryName } = organization!;

	// TODO "!"
	const contactProfileFaqCollectionNotUndefined = contactProfileFaqCollection!;

	const faqsMobile = contactProfileFaqCollectionNotUndefined;

	const faqsFirstColumn: ContactProfileFaq[] = [];
	const faqsSecondColumn: ContactProfileFaq[] = [];

	contactProfileFaqCollectionNotUndefined.forEach((co, nu) => {
		(
			nu % 2 === 0
				? faqsFirstColumn
				: faqsSecondColumn
		)
			.push(co);
	});

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		setIsMobile(getViewportIsMobile());

		addViewportIsMobileListener((bo) => setIsMobile(bo));
	}, []);

	return (
		<Paper
			title={`Frequently Asked Questions regarding ${givenName} ${familyName}`}
			blockName="faqs"
			blockId="faq-block"
		>
				<div className="hidden-xs hidden-sm faq-more-info mb-4">
					<div className="col-xs-12 text-right float-right">
						<a href={contactCompanyProfileHref} className="anchor">
							See more information about
							{" "}

							{primaryName}

							<span className="right-arrow" />
						</a>
					</div>
				</div>

				<div className="row faq-wrap">
					{
						isMobile
							? <div className="col-md-12">
								{
									faqsMobile.map((co, nu) => <div
										className="row"
										key={nu}>
										<FaqCard
											contactProfileFaq={co}
											index={nu}
										/>
									</div>)
								}
							</div>
							:
							<>
								<div className="col-md-6">
									{
										faqsFirstColumn.map((co, nu) => (
											<div key={nu}>
												<FaqCard
													contactProfileFaq={co}
													index={nu}
												/>
											</div>
										))
									}
								</div>

								<div className="col-md-6">
									{
										faqsSecondColumn.map((co, nu) => (
											<div key={nu}>
												<FaqCard
													contactProfileFaq={co}
													index={nu}
												/>
											</div>
										))
									}
								</div>
							</>
					}
				</div>

				<div className="row hidden-lg hidden-md faq-more-info">
					<div className="col-xs-12 text-center">
						<a href={contactCompanyProfileHref}>
							See more information about

							{" "}

							{primaryName}

							<span className="right-arrow" />
						</a>
					</div>
				</div>
		</Paper>
	);
};

export default ContactProfileFAQ;
